module.exports = __webpack_public_path__ + "img/charging-hub-disabled-semipublic.1c8e1afe.png";